<ng-container *ngIf="{customerProfile: customerProfile$ | async} as data">
  <button class="button-icon button-icon--th-ctrl" *ngIf="!data.customerProfile" (click)="onLogin()">
    <i class="icomoon icomoon--user"></i>
  </button>

  <button routerLink="/customer-area" class="button button--th-ctrl" type="button" *ngIf="data.customerProfile">
    <span class="button__icon">
      <i class="icomoon icomoon--user"></i>
    </span>
    <span class="button__text" *ngIf="data.customerProfile.name">{{ data.customerProfile.name }}</span>
  </button>
</ng-container>

<ng-template #authModalView></ng-template>
